import { ELOQUENT } from 'config/constants';

/**
 * Get training videos list
 *  @param {Object} query
 * @returns {Promise}
 */
export function getAllTrainingVideosList(query) {
    return ELOQUENT.TrainingVideo.getAll(query);
}

/**
 * Get training videos list
 * @returns {Promise}
 *  @param {Number|String} productId
 */
export function getProductsTrainingVideos(productId) {
    return ELOQUENT.TrainingVideo.getAll();
}

/**
* Create a new Training Video
*  @returns {Promise}
*  @param {Object} data
*/
export function createTrainingVideo(data) {
    return ELOQUENT.TrainingVideo.createOne(data);
}

/**
* Update a Training Video
*  @returns {Promise}
*  @param {String | Number} id
*  @param {Object} data
*/
export function updateTrainingVideo(id, data) {
    return ELOQUENT.TrainingVideo.updateOne(id, data);
}

/**
 * Delete a Training Video
 *  @returns {Promise}
 *  @param {Number|String} videoId
 */
export function deleteTrainingVideo({ videoId }) {
    return ELOQUENT.TrainingVideo.deleteOne(videoId);
}

/**
 * Sync Training Videos
 *  @returns {Promise}
 *  @param {Object} data
 */
export function syncTrainingVideo(data) {
    return ELOQUENT.TrainingVideo.transformModel(data);
}
